import $ from 'jquery';

const init = () => {

  $(function() {
    $('.js-table-block-dropdown')
      .on('change', function() {
        const $parent = $(this).closest('.table-block');
        $parent.find('.js-table-block').hide();
        $parent.find('#' + $(this).val()).show();
        $(this).blur();
      })
      .trigger('change');
  });

};

export {
  init
}